import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

const OPTIONS = [
  { k: "trade", l: "Trades", d: "Buys and sells you make" },
  { k: "alert", l: "Price alerts", d: "When BTC hits your target price" },
  { k: "autobuy", l: "Auto-buys", d: "Scheduled buys that succeed or fail" },
  { k: "withdrawal", l: "Withdrawals", d: "Payouts sent to your bank" },
  { k: "admin", l: "Admin alerts", d: "Withdrawals and contact messages from users", admin: true },
];

export const EmailPrefs = () => {
  const [prefs, setPrefs] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    api.get("/settings/email-prefs").then(({ data }) => { setPrefs(data.prefs); setIsAdmin(data.is_admin); }).catch((e) => toast.error(errMsg(e)));
  }, []);

  const toggle = async (k, v) => {
    const prev = prefs;
    setPrefs({ ...prefs, [k]: v });
    try {
      const { data } = await api.put("/settings/email-prefs", { ...prefs, [k]: v });
      setPrefs(data.prefs);
      toast.success("Email preferences saved");
    } catch (e) {
      setPrefs(prev);
      toast.error(errMsg(e));
    }
  };

  if (!prefs) return <p className="py-6 text-center text-xs text-[#64748B]">Loading...</p>;
  return (
    <div className="space-y-2" data-testid="email-prefs-panel">
      {OPTIONS.filter((o) => !o.admin || isAdmin).map((o) => (
        <label key={o.k} className="flex cursor-pointer items-center justify-between rounded-xl border border-[#212638] bg-[#0F111A] px-4 py-3">
          <span><span className="block text-sm font-semibold">{o.l}</span><span className="text-xs text-[#94A3B8]">{o.d}</span></span>
          <Switch checked={prefs[o.k]} onCheckedChange={(v) => toggle(o.k, v)} data-testid={`email-pref-${o.k}-switch`} />
        </label>
      ))}
    </div>
  );
};
